<div class="pr-3  pl-4 h-full w-full flex flex-col" (window:resize)="onResize()">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page"><span class="title">Báo cáo thông tin người khuyết tật</span>
      <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
    </div>
    <div class="btn-option flex">
      <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
        <button nz-button class="flex items-center justify-center" nzTooltipTitle="Xuất excel"
          nzTooltipPlacement="bottom" nz-tooltip (click)="exportExcel()">
          <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
        <button nz-button class="flex items-center justify-center" (click)="exportExcel()">
          Xuất excel
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
        <button nz-button class="flex items-center justify-center" (click)="exportExcel()">
          <i nz-icon nzType="file-excel" nzTheme="twotone"></i>
          Xuất excel
        </button>
      </ng-container>
    </div>
  </div>
  <form nz-form class="ant-advanced-search-form" #pageSearch>
    <div nz-row [nzGutter]="24">
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzRequired>Năm</nz-form-label>
          <nz-date-picker nzMode="year" [(ngModel)]="year" [ngModelOptions]="{standalone: true}"
            nzPlaceHolder="Nhập năm" (nzOnOpenChange)="changeYear()"></nz-date-picker>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Tỉnh thành</nz-form-label>
          <asc-autocomplete  [disabled]="isDisabled || isDisabled1 || isDisabled2"  [ascModel]="DisProvincesControl" (ascModelChange)="changeDisProvincesACFn($event)"
            placeholder="Chọn tỉnh thành..." [getListAC]="getDisProvincesACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Quận huyện</nz-form-label>
          <asc-autocomplete [disabled]="isDisabled || isDisabled2" [ascModel]="DistrictControl" (ascModelChange)="changeDistrictACFn($event)"
            placeholder="Chọn quận huyện..." [getListAC]="getDistrictACFn">
          </asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Phường xã</nz-form-label>
          <asc-autocomplete [ascModel]="WardControl" (ascModelChange)="changeWard($event)"
            [placeholder]="'Chọn phường xã'" [getListAC]="getWardACFn"></asc-autocomplete>
        </nz-form-item>
      </div>
      <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
        <nz-form-item>
          <nz-form-label nzSpan="24">Dạng tật</nz-form-label>
          <asc-autocomplete [ascModel]="TypeOfDisabilityControl" (ascModelChange)="changeTypeOfDisability($event)"
            [placeholder]="'Chọn dạng...'" [getListAC]="getTypeOfDisabilityACFn"></asc-autocomplete>
        </nz-form-item>
      </div>
      <ng-container *ngIf="!isCollapse">
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Mức độ khuyết tật</nz-form-label>
            <asc-autocomplete [ascModel]="LevelControl" (ascModelChange)="changeLevel($event)"
              [placeholder]="'Chọn mức độ khuyết tật...'" [getListAC]="getLevelACFn"></asc-autocomplete>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Tình trạng giáo dục</nz-form-label>
            <asc-autocomplete [ascModel]="caDisEducationalStatusesControl"
              (ascModelChange)="changeCaDisEducationalStatuses($event)" placeholder="Chọn tình trạng giáo dục..."
              [getListAC]="getCaDisEducationalStatusessACFn">
            </asc-autocomplete>
          </nz-form-item>
        </div>

        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Phương thức giáo dục</nz-form-label>
            <asc-autocomplete [ascModel]="ModesOfEducationControl" (ascModelChange)="changeModesOfEducation($event)"
              placeholder="Chọn phương thức giáo dục..." [getListAC]="getModesOfEducation">
            </asc-autocomplete>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label nzSpan="24">Nhu cầu hỗ trợ</nz-form-label>
            <asc-autocomplete [ascModel]="EducationalSupportControl" (ascModelChange)="changeEducationalSupport($event)"
              placeholder="Chọn nhu cầu hỗ trợ..." [getListAC]="getEducationalSupport">
            </asc-autocomplete>
          </nz-form-item>
        </div>
        <div nz-col nzSm="24" nzMd="12" nzLg="6" nzXl="6">
          <nz-form-item>
            <nz-form-label #label nzFor="studyModeId" nzSpan="24">Hình thức học</nz-form-label>
            <asc-autocomplete [ascModel]="DisStudyModeControl" (ascModelChange)="changeDisStudyMode($event)"
              placeholder="Chọn Hình thức học..." [getListAC]="getDisStudyModeACFn">
            </asc-autocomplete>
          </nz-form-item>
        </div>
      </ng-container>
      <div nz-col *ngIf="isCollapse" nzSpan="24">
        <div style="visibility: hidden; margin-top: 5px">i</div>
      </div>
    </div>
    <div nz-row>
      <div nz-col [nzSpan]="24" class="search-area">
        <button nz-button class="flex items-center justify-center" [nzTooltipTitle]="isCollapse ? 'Mở rộng' : 'Đóng'"
          nz-tooltip (click)="toggleCollapse()"><i nz-icon nzType="filter" nzTheme="outline"></i></button>
        <button nz-button class="flex items-center justify-center" (click)="clear()" nzTooltipTitle="Xóa tìm kiếm"
          nzTooltipPlacement="bottom" nz-tooltip><i nz-icon nzType="clear" nzTheme="outline"></i></button>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="reload()">Tìm
            kiếm</button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
          <button nz-button class="flex items-center justify-center" style="width: 100px;" [nzType]="'primary'"
            nzTooltipTitle="Tìm kiếm" nzTooltipPlacement="bottom" nz-tooltip (click)="reload()"><i nz-icon
              nzType="search" nzTheme="outline"></i></button>
        </ng-container>
        <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
          <button nz-button class="flex items-center justify-center" [nzType]="'primary'" (click)="reload()"><i nz-icon
              nzType="search" nzTheme="outline"></i>Tìm kiếm</button>
        </ng-container>
      </div>
    </div>
  </form>
  <div class="relative">
    <nz-table [nzShowTotal]="rangeTemplate" #Table nzOuterBordered nzShowSizeChanger [nzData]="dataTable" nzSize="small"
      [nzScroll]="{x: width +'px', y: height + 'px'}" class="absolute w-full" [nzFrontPagination]="false"
      [nzTotal]="Total" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex" [nzPageSizeOptions]="pageSizeOptions"
      (nzPageIndexChange)="pageIndexEvent($event)" (nzPageSizeChange)="pageSizeEvent($event)">
      <thead>
        <tr #pageHeaderTable>
          <th nzWidth="50px" rowspan="2" nzLeft>STT
          </th>
          <th rowspan="2" nzWidth="200px" nzLeft>Họ tên</th>
          <th rowspan="2" nzWidth="100px">Giới tính</th>
          <th rowspan="2" nzWidth="100px">Năm sinh</th>
          <th rowspan="2" nzWidth="100px">Dân tộc</th> 
          <th  colspan="3">Nơi ở hiện nay</th> 
          <th rowspan="2" nzWidth="100px">Giấy xác nhận KT</th>
          <th rowspan="2" nzWidth="100px">Hỗ trợ giáo dục</th>
          <th rowspan="2" nzWidth="150px">Dạng tật</th>
          <th rowspan="2" nzWidth="110px">Mức độ khuyết tật</th>
          <th rowspan="2" nzWidth="100px">Tình trạng giáo dục</th>
          <th rowspan="2" nzWidth="100px">Đang đi học (lớp/năm thứ)</th>
          <th rowspan="2" nzWidth="100px">Bỏ học (lớp/năm thứ)</th>
          <th rowspan="2" nzWidth="100px">Đã hoàn thành (cấp học)</th>
          <th rowspan="2" nzWidth="100px">Chưa đi học</th>
          <th rowspan="2" nzWidth="100px">Tình trạng can thiệp</th>
          <!-- <th rowspan="2" nzWidth="150px">Phương thức giáo dục</th>
          <th rowspan="2" nzWidth="100px">Hình thức học</th>  -->
          <th rowspan="2" nzWidth="150px">Nhu cầu hỗ trợ</th>
        
          <th rowspan="2" nzWidth="200px">Nhận biết chính sách GD cho người khuyết tật</th>
          <th rowspan="2" nzWidth="200px">Tiếp nhận thông tin về các chính sách từ nguồn</th>
          <th rowspan="2" nzWidth="150px">Sự phối hợp của cộng đồng trong thực hiện chính sách giáo dục người khuyết tật</th>
          <th rowspan="2" nzWidth="100px">Sự phối hợp của chính quyền và ban ngành địa phương</th>
          <th rowspan="2" nzWidth="100px">Tình trạng việc làm</th>
          <th rowspan="2" nzWidth="100px">Tình trạng hôn nhân</th>
          <th rowspan="2" nzWidth="100px">Đang sống tại</th>
          <th rowspan="2" nzWidth="150px">Thể chất, vận động</th>
          <th rowspan="2" nzWidth="150px">Nhận thức</th>
          <th rowspan="2" nzWidth="150px">Ngôn ngữ giao tiếp</th>
          <th rowspan="2" nzWidth="150px">Tự phục vụ</th>
          <th rowspan="2" nzWidth="150px">Hành vi</th>
         
          <th colspan="10">CMHS/người đỡ đầu</th>
          <th colspan="2">Phát triển thể chất và vận động</th>
          <th colspan="2">Phát triển nhận thức/học tập</th>
          <th colspan="2">Phát triển ngôn ngữ- giao tiếp</th>
          <th colspan="2">Giáo dục kỹ năng tự phục vụ</th>
          <th colspan="2">Quản lý hành vi</th>
          <th rowspan="2" nzWidth="100px">Điều kiện kinh tế gia đình</th>
        </tr>

        <!-- <tr #pageHeaderTable1> 
          <th>Tỉnh thành</th>
          <th>Quận huyện</th>  
          <th>Phường xã</th>  
        </tr> -->
        <tr #pageHeaderTable2> 
          <th nzWidth="300px">Tỉnh thành</th>
          <th nzWidth="300px">Quận huyện</th>  
          <th nzWidth="300px">Phường xã</th>  
          <th>Họ và tên</th>
          <th>Trình độ</th>  
          <th>Mối quan hệ với người khuyết tật</th> 
          <th>Bồi dưỡng về GDĐ</th> 
          <th>Nghề nghiệp</th> 
          <th>Nhận biết chính sách giáo dục NKT</th> 
          <th>Tiếp nhận thông tin về các chính sách từ nguồn</th> 
          <th>Sự phối hợp của cộng đồng trong thực hiện chính sách giáo dục NKT</th> 
          <th>Sự phối hợp của chính quyền và ban ngành địa phương</th> 
          <th>Mong muốn của ông/bà đối với NKT</th> 
          <th>Đã được đào tạo bồi dưỡng</th> 
          <th>Nhu cầu được đào tạo bồi dưỡng</th> 
          <th>Đã được đào tạo bồi dưỡng</th> 
          <th>Nhu cầu được đào tạo bồi dưỡng</th> 
          <th>Đã được đào tạo bồi dưỡng</th> 
          <th>Nhu cầu được đào tạo bồi dưỡng</th> 
          <th>Đã được đào tạo bồi dưỡng</th> 
          <th>Nhu cầu được đào tạo bồi dưỡng</th> 
          <th>Đã được đào tạo bồi dưỡng</th> 
          <th>Nhu cầu được đào tạo bồi dưỡng</th> 
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of Table.data; let i = index">
          <td nzLeft>{{ i + 1 + (pageIndex-1)*pageSize }}</td>
          <td nzLeft>{{data.fullName}}</td>
          <td>{{data.gender| gender}}</td>
          <td>{{data.yearOfBirth}}</td>
          <td>{{data.folkName}}</td> 
          <td>{{data.provinceName}}</td> 
          <td>{{data.districtName}}</td> 
          <td>{{data.wardName}}</td> 
          <td>{{data.disDisabilityCertificateType| disDisabilityCertificateType}}</td>
          <td>{{data.supportedEducation == false ? 'Chưa' : 'Có'}}</td>
          <td>{{data.typeOfDisability}}</td>
          <td>{{data.levelName}}</td>
          <td>{{data.educationalStatus}}</td>
          <td>{{data.dangDiHoc}}</td>
          <td>{{data.boHoc}}</td>
          <td>{{data.daHoanThanh}}</td>
          <td>{{data.chuaDiHoc}}</td>
          <td>{{data.studentSurveyInterventionStatus}}</td>
          <!-- <td>{{data.modesOfEducation}}</td>
          <td nzTooltipTitle="{{data.studyMode}}" nzTooltipPlacement="top" nz-tooltip class="text-hidden">
            {{data.studyMode}}</td>  -->
          <td>{{data.intervention}}</td>
      
          <td>{{data.disabilityPolicies}}</td>
          <td>{{data.informationSource}}</td>
          <td>{{data.communityCoordination == false ? 'Chưa' : 'Có'}}</td>
          <td>{{data.localGovernmentCoordination == false ? 'Chưa' : 'Có'}}</td>
          <td>{{data.employmentStatusName}}</td>
          <td>{{data.maritalStatusName}}</td>
          <td>{{data.caregiverName}}</td> 
          <td>{{data.theChat}}</td>
          <td>{{data.nhanThuc}}</td>
          <td>{{data.ngonNguGiaoTiep}}</td>
          <td>{{data.tuPhucVu}}</td>
          <td>{{data.hanhVi}}</td>
          <td>{{data.tutorName}}</td>
          <td>{{data.tutorEducationLevel}}</td>  
          <td>{{data.tutorRelationshipName}}</td>
          <td>{{data.tutorCertificate == "0" ? 'Chưa' : 'Có'}}</td>
          <td>{{data.tutorCareer}}</td> 
          <td>{{data.studentSurveyTutorDisabilityPolicy }}</td> 
          <td>{{data.studentSurveyTutorInformationSource}}</td>
          <td>{{data.tutorCommunityCoordination == false ? 'Chưa' : 'Có'}}</td>
          <td>{{data.tutorLocalGovernmentCoordination == false ? 'Chưa' : 'Có'}}</td>
          <td>{{data.studentSurveyTutorEducationSupport}}</td>
          <td>{{data.phatTrienTheChatVanDongDaDaoTao == false ? 'Chưa' : 'Có'}}</td>
          <td>{{data.phatTrienTheChatVanDongNhuCau == false ? 'Chưa' : 'Có'}}</td>
          <td>{{data.phatTrienNhanThucHocTapDaDaoTao == false ? 'Chưa' : 'Có'}}</td>
          <td>{{data.phatTrienNhanThucHocTapNhuCau == false ? 'Chưa' : 'Có'}}</td>
          <td>{{data.phatTrienNgonNguGiaoTiepDaDaoTao == false ? 'Chưa' : 'Có'}}</td>
          <td>{{data.phatTrienNgonNguGiaoTiepNhuCau == false ? 'Chưa' : 'Có'}}</td>
          <td>{{data.giaoDucKyNangTuPhucVuDaDaoTao == false ? 'Chưa' : 'Có'}}</td>
          <td>{{data.giaoDucKyNangTuPhucVuNhuCau == false ? 'Chưa' : 'Có'}}</td>
          <td>{{data.quanLyHanhViDaDaoTao == false ? 'Chưa' : 'Có'}}</td>
          <td>{{data.quanLyHanhViNhuCau == false ? 'Chưa' : 'Có'}}</td>

          <td>{{data.livingConditions}}</td> 
        </tr>
      </tbody>
    </nz-table>
  </div>
</div>
<ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
<ng-template #rangeTemplate let-range="range" let-total> {{ range[0] }}-{{ range[1] }} của {{ Total }} </ng-template>
